import React, { Fragment, useMemo } from 'react';

import { JRCAlbumItemProps } from '../types';
import { AlbumButton } from '../styles';

import { AlbumItem } from './AlbumItem';
import { ALBUM_DEFAULT_MAX_WIDTH } from '../const';

export const AlbumX1 = ({ files, maxWidth = ALBUM_DEFAULT_MAX_WIDTH, maxHeight, onClick }: JRCAlbumItemProps) => {
    const height = useMemo(() => Math.floor(maxHeight ?? maxWidth / (16 / 9)), [maxWidth, maxHeight]);
    return (
        <Fragment>
            {files.map((file) => (
                <AlbumButton onClick={() => onClick(file.id)} key={file.uri} data-testid={`album-button-${file.id}`}>
                    <AlbumItem file={file} width={maxWidth} height={height} />
                </AlbumButton>
            ))}
        </Fragment>
    );
};
